export default {
  "config": {
    "trial": "driving",
    "id": "teaes",
    "type": "table",
    "title": "Common TEAEs (Incidence <no-break>≥5%</no-break> Overall)<sup>29</sup>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>"
    ],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "driving",
    "id": "teaes",
    "data-type": "table",
    "title": "Common TEAEs (Incidence <no-break>≥5%</no-break> Overall)<sup>29</sup>",
    "num-header-rows": 1,
    "num-columns": 3,
    "col-classes": [
      "col-1",
      "pbo",
      "sol"
    ],
    "row-mergeoption": [
      1
    ],
    "footnote-tooltip": "disable",
    "footnote-order": [
      "footnote-note1"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
    "data": {
      "row-0": [
        {
          "indent": 0,
          "content": "<b>TEAE, <no-break>n (%)</no-break></b>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<b>Placebo <no-break>(n = 33)</no-break></b>",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "<b>Solriamfetol <no-break>(n = 34)</no-break></b>",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-1": [
        {
          "indent": 0,
          "content": "Headache",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "4 (12.1)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "5 (14.7)",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-2": [
        {
          "indent": 0,
          "content": "Nausea",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "2 (6.1)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "4 (11.8)",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-3": [
        {
          "indent": 0,
          "content": "Insomnia",
          "cols": 1,
          "class": "col-1"
        },
        {
          "content": 0,
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "4 (11.8)",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-4": [
        {
          "indent": 0,
          "content": "Dizziness",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "2 (6.1)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "3 (8.8)",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-5": [
        {
          "indent": 0,
          "content": "Agitation",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "1 (3.0)",
          "cols": 1,
          "class": "pbo"
        },
        {
          "indent": 0,
          "content": "1 (2.9)",
          "cols": 1,
          "class": "sol"
        }
      ]
    }
  }
};